import http from './http-common'

export const findPlans = () => {
    return http.get(`/planHistory`)
}